import { useEffect, useState } from 'react'
import { Outlet } from 'react-router-dom'
import { materialCalculatorApi } from '../../services/materialCalculator'
import MCFeatureDisabledPage from './components/MCFeatureDisabledPage'

export default function MaterialCalculatorFeatureGate() {
  const [state, setState] = useState({ loading: true, enabled: false })

  useEffect(() => {
    let active = true
    materialCalculatorApi.status()
      .then(() => active && setState({ loading: false, enabled: true }))
      .catch((err) => {
        if (!active) return
        if (err.status === 402) setState({ loading: false, enabled: false })
        else setState({ loading: false, enabled: true })
      })
    return () => { active = false }
  }, [])

  if (state.loading) {
    return <div className="flex items-center justify-center py-20"><div className="h-10 w-10 rounded-full border-b-2 border-primary-600 animate-spin" /></div>
  }

  if (!state.enabled) return <MCFeatureDisabledPage />

  return <Outlet />
}
